<!-- https://www.olympus-ims.com/en/software-license-agreement/ -->

<div class="standalone-license-texts">

  <h3 fxLayoutAlign="center">{{ 'licenseAgreementForStandalone.softwareLicenceAgreement' | translate }}</h3>

  <p>{{ 'licenseAgreementForStandalone.preamble01' | translate }}</p>
  <p>{{ 'licenseAgreementForStandalone.preamble02' | translate }}</p>

  <p class="section-title">{{ 'licenseAgreementForStandalone.section01Title' | translate }}</p>
  <ol>
    <li>{{ 'licenseAgreementForStandalone.section01Paragraph01' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section01Paragraph02' | translate }}</li>
  </ol>

  <p class="section-title">{{ 'licenseAgreementForStandalone.section02Title' | translate }}</p>
  <ol>
    <li>{{ 'licenseAgreementForStandalone.section02Paragraph01' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section02Paragraph02' | translate }}</li>
    <li>
      {{ 'licenseAgreementForStandalone.section02Paragraph03-1' | translate }}
      <a href="{{openSourceSoftwareUrl}}"
         target="_blank">{{ 'licenseAgreementForStandalone.section02Paragraph03-openSourceSoftware' | translate }}</a>
      {{ 'licenseAgreementForStandalone.section02Paragraph03-2' | translate }}
    </li>
  </ol>

  <p class="section-title">{{ 'licenseAgreementForStandalone.section03Title' | translate }}</p>
  <ol>
    <li>{{ 'licenseAgreementForStandalone.section03Paragraph01' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section03Paragraph02' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section03Paragraph03' | translate }}</li>
  </ol>

  <p class="section-title">{{ 'licenseAgreementForStandalone.section04Title' | translate }}</p>
  <p>{{ 'licenseAgreementForStandalone.section04Paragraph01' | translate }}</p>

  <p class="section-title">{{ 'licenseAgreementForStandalone.section05Title' | translate }}</p>
  <ol>
    <li>{{ 'licenseAgreementForStandalone.section05Paragraph01' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section05Paragraph02' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section05Paragraph03' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section05Paragraph04' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section05Paragraph05' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section05Paragraph06' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section05Paragraph07' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section05Paragraph08' | translate }}</li>
  </ol>
  <p>{{ 'licenseAgreementForStandalone.section05Paragraph08Condition01' | translate }}</p>
  <p>{{ 'licenseAgreementForStandalone.section05Paragraph08Condition02' | translate }}</p>
  <p>{{ 'licenseAgreementForStandalone.section05Paragraph08Condition03' | translate }}</p>
  <p>{{ 'licenseAgreementForStandalone.section05Paragraph08Condition04' | translate }}</p>

  <p class="section-title">{{ 'licenseAgreementForStandalone.section06Title' | translate }}</p>
  <ol>
    <li>{{ 'licenseAgreementForStandalone.section06Paragraph01' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section06Paragraph02' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section06Paragraph03' | translate }}</li>
  </ol>

  <p class="section-title">{{ 'licenseAgreementForStandalone.section07Title' | translate }}</p>
  <ol>
    <li>{{ 'licenseAgreementForStandalone.section07Paragraph01' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section07Paragraph02' | translate }}</li>
  </ol>

  <p class="section-title">{{ 'licenseAgreementForStandalone.section08Title' | translate }}</p>
  <ol>
    <li>{{ 'licenseAgreementForStandalone.section08Paragraph01' | translate }}</li>
    <li>{{ 'licenseAgreementForStandalone.section08Paragraph02' | translate }}</li>
  </ol>

  <p class="section-title">{{ 'licenseAgreementForStandalone.section09Title' | translate }}</p>
  <p>{{ 'licenseAgreementForStandalone.section09Paragraph01' | translate }}</p>

</div>
